import { STRINGS } from '../../constants';
import filterEmptyParams from '../../utils/filters';
import apiCaller from '../http';
import URLS from '../urls';

const createVisitByWorkshop = async (
  data,
  setError,
  setIsLoading,
  visitNavigator,
  logoutHandler,
) => {
  const payload = {
    workshop_scan_car_qr_id: data?.scannedCarId,
    car_ownership_id: data?.carOwnershipId,
    workshop_ownership_id: data?.workshopOwnershipId,
    message_from_workshop: data?.message,
    selected_time: data?.selectedTime,
  };
  await apiCaller
    .post(URLS.VISIT_CREATE_BY_WORKSHOP, filterEmptyParams(payload))
    .then((resp) => {
      if (resp.data !== undefined) {
        setError(null);
        visitNavigator(resp.data.id);
      } else {
        setError(STRINGS.common.error404Text);
      }
      setError(null);
    })
    .catch((e) => {
      setIsLoading(false);
      if (e.message === STRINGS.common.errorMissingCredentials) {
        logoutHandler();
      }
      if (e.message === STRINGS.common.error400Template) {
        setError(STRINGS.common.error400Text);
      }
    });
};

export default createVisitByWorkshop;
